
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { LOGIN_API } from '../config/API';
import { useUser } from '../context/UserContext';
import axios from 'axios';
import './Login.css';

const Login = () => {
    const navigate = useNavigate();
    const { refreshUserAccess } = useUser();
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post(LOGIN_API, {
                identifier,
                password,
            });

            const data = response.data;

            // ✅ Store tokens
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);
            localStorage.setItem('user', JSON.stringify(data.user));

            await refreshUserAccess();
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.error || err.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>Welcome Back</h1>
                    <p>Enter your credentials to access your account</p>
                </div>

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Username</label>
                        <input
                            type="text"
                            placeholder="xyz"
                            className="form-input"
                            value={identifier}
                            onChange={(e) => setIdentifier(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="••••••••"
                            className="form-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {/* <Link to="/forgot-password" className="forgot-password">
                            Forgot password?
                        </Link> */}
                    </div>
                    {error && <p className="error-text">{error}</p>}
                    <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? 'Signing In...' : 'Sign In'}
                    </button>
                </form>

            </div>
        </div>
    );
};

export default Login;


